module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"cta-label":"Eu quero","order-creation-error":"Houve um erro no processamento do seu pedido. Tente novamente ou fale com o suporte.","media-number-error":"Selecione ao menos uma mídia para adicioná-la ao seu acervo."}}')
  delete Component.options._Ctor
}
